
export default class Business {

}

